// Animated organic mesh-gradient backdrop — three soft brand-colored blobs
// (coral / pink / indigo) that drift and cross the screen on independent,
// desynced loops so they never move in lockstep. Blob styling + motion live in
// index.css (.mesh-blob + meshBlob1/2/3 keyframes); reduced-motion holds them
// still. Drop as the FIRST child of a `relative overflow-hidden` page root, then
// give the real content `relative z-10`. Reusable across auth / marketing / app.

export function MeshBg() {
  return (
    <div
      aria-hidden
      className="pointer-events-none absolute inset-0 overflow-hidden bg-surface"
    >
      <div className="mesh-blob-layer">
        <div className="mesh-blob mesh-blob--1" />
        <div className="mesh-blob mesh-blob--2" />
        <div className="mesh-blob mesh-blob--3" />
      </div>
    </div>
  );
}
